<template>
  <div id="scheduleDetail_combinedResult">
    <NOT_DATA
      :className="'relativePtb30'"
      v-if="localDataProp && !localDataProp.isHasData"
    />
    <template v-else>
      <EVENTCOP_MODE_3
        v-if="
          localDataProp &&
          localDataProp.eventCompModeObj &&
          localDataProp.eventCompModeObj[tabTypeKey] === 'mode_3' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="tabTypeKey"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_3>

      <div
        class="note_box"
        v-show="
          eventCompModeDatas.annotation &&
          eventCompModeDatas.annotation.length > 0
        "
      >
        <span class="note_title" v-text="'注释'"></span>
        <span class="note_info">
          <span
            class="noteInfo_item"
            v-for="(item, index) in eventCompModeDatas.annotation"
            :key="index"
            v-text="`${item.name}：${item.explain}`"
          ></span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
// 适用： 全能成绩 【体操|艺术体操】
import cup_base_data_mixin from '@mixins/cup_base_data'
import NOT_DATA from '@components/base/NO_DATA.vue'
import EVENTCOP_MODE_3 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_3.vue'
export default {
  name: 'scheduleDetail_combinedResult',
  mixins: [cup_base_data_mixin],
  components: {
    NOT_DATA,
    EVENTCOP_MODE_3,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    scheduleDetailDatas: {
      type: Object,
      default: () => ({}),
    },
    localDataProp: {
      type: Object,
      default: () => ({
        datas: null, //初始化时为null, 一旦赋值过只能为正常数据||{}
        isHasData: true,
        eventCompMode: '', //mode_1
        type: '',
        competitorType: '',
      }),
    },
  },
  watch: {
    localDataProp: {
      handler(newVal, oldVal) {
        console.debug('combinedResult 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          let eventCompModeDatas = {}
          // 组装成eventComp_mode_x需要的格式
          if (
            newVal.datas &&
            newVal.datas.result_total &&
            newVal.datas.result_total.result_data
          ) {
            console.debug(
              'combinedResult:',
              newVal.datas.result_total.result_data.detail_list
            )
            eventCompModeDatas = {
              data: newVal.datas.result_total.result_data.detail_list,
              table_head: newVal.datas.result_total.result_data.table_head,
              annotation: newVal.datas.result_total.annotation,
            }
          }
          this.eventCompModeDatas = JSON.parse(
            JSON.stringify(eventCompModeDatas)
          )
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      // eventCompMode: 'mode_2',
      tabTypeKey: 'combinedResult',
      eventCompModeDatas: null,
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   // window.scrollTo(0, Math.floor(30.776 * this.vw2px))
    //   window.scrollTo(0, Math.floor((12.36+0.694) * this.vw2px))
    // })
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
#scheduleDetail_combinedResult {
  padding-bottom: 2.083vw;
  .note_box {
    width: 100%;
    padding: 0.694vw 1.338vw 4.16vw;
    /* border-top: 1px solid var(--mixtmt_greyColor8); */
    .note_title {
      display: block;
      font-size: 1.11vw;
      color: var(--mixtmt_mainColor);
      line-height: 2.083vw;
      font-weight: bold;
    }
    .note_info {
      width: 100%;
      padding: 0 0.694vw 0 0;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .noteInfo_item {
        width: auto;
        min-width: 12.5%;
        text-align: left;
        font-size: 1.11vw;
        line-height: 2.5vw;
        color: var(--mixtmt_greyColor2);
        padding-left: 1.388vw;
        &:first-child {
          padding-left: 0.694vw;
        }
      }
    }
  }
}
</style>
